module.exports = __webpack_public_path__ + "media/images/athletes/3600-3cb6ec64c3756f2c8fd0303966f47c3c.png";